<template>
  <div class="search-form">
    <div class="form-group text-left">
      <label class="nom_distance_label">Select</label>

      <div class="order_by_distance_panel">
        <label class="custom-control custom-radio">
          <input
            type="radio"
            value="competitor"
            v-model="selectBy"
            class="custom-control-input"
          />
          <span class="custom-control-label font-weight-normal">Competitor</span>
        </label>

        <label class="custom-control custom-radio">
          <input
            type="radio"
            value="horse"
            v-model="selectBy"
            class="custom-control-input"
          />
          <span class="custom-control-label font-weight-normal">Horse</span>
        </label>
      </div>
    </div>

    <multiselect
      v-model="selected"
      :options="results"
      :searchable="true"
      :loading="isLoading"
      :clear-on-select="false"
      :hide-selected="true"
      :placeholder="`Select ${selectBy}`"
      :label="labelField"
      :track-by="trackField"
      @search-change="onSearchChange"
      @open="onOpen"
      select-label=""
      @input="selectItem"
    >
      <template #noResult>
        No results found
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from '@/components/AppMultiselect'
import fetchData from '../../../../../mixins/apiHelpers'

export default {
  inject: ['entity'],
  components: { Multiselect },
  data() {
    return {
      selectBy: (this.$route.query.select === 'horse') ? 'horse' : 'competitor',
      results: [],
      isLoading: false,
      timeout: null,
      draftId: null,
      selected: null,
      searchTimeout: null,
      isSelecting: false
    }
  },
  watch: {
    selectBy() {
      this.results = []
      this.selected = null
    }
  },
  computed: {
    labelField() {
      return (this.selectBy === 'competitor') ? 'rider_name' : 'name'
    },
    trackField() {
      return (this.selectBy === 'competitor') ? 'user_member_id' : 'horse_id'
    }
  },
  methods: {
    onInput() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(this.search, 500)
    },
    onOpen() {
      if (this.results.length === 0) {
        this.search()
      }
    },
    onSearchChange(query) {
      if (this.isSelecting) {
        this.isSelecting = false
        return
      }

      if (this.searchTimeout) clearTimeout(this.searchTimeout)

      this.searchTimeout = setTimeout(() => {
        this.search(query)
      }, 500)
    },
    async search(query) {
      this.results = []
      this.isLoading = true
      const url =
        this.selectBy === 'competitor'
          ? `/leaders/drafts/${this.entity.id}/competitors`
          : `/leaders/drafts/${this.entity.id}/horses`

      fetchData(`${this.$api}${url}`, (response) => {
        this.results = response.data.data?.riders || response.data.data?.horses
        this.isLoading = false
      }, this, {
        params: {
          [`${(this.selectBy === 'competitor') ? 'rider_name' : 'name'}`]: query
        }
      })
    },
    selectItem(item) {
      if (!item) return

      this.isSelecting = true
      const currentQuery = { ...this.$route.query }

      currentQuery.id = item[this.trackField]
      currentQuery.select = this.selectBy

      this.$router.push({
        path: this.$route.path,
        query: currentQuery
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
  .leaders a {
    color: var(--apperances-color) !important;
  }

  .search-form .custom-control-input:checked ~ .custom-control-label::before {
    border-color: var(--apperances-color);
    background-color: var(--apperances-color);
  }

  .multiselect__option--highlight {
    background-color: var(--apperances-color);
  }

  .multiselect__element--highlight {
    background-color: var(--apperances-color);
  }

  .multiselect {
    max-width: 390px;
    width: 100%;
  }

  .multiselect * {
    font-size: 1rem !important;
  }

  .multiselect__tags {
    font-size: 1rem !important;
    border: 1px solid var(--light);
  }

  .multiselect__select::before {
    color: var(--gray-700);
    border-color: var(--gray-700) #0000 #0000;
  }
</style>


// WEBPACK FOOTER //
// src/views/Leaders/Listing/components/Search/SearchForm.vue